(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["early-access"] && !Shopify.designMode) return;
  try {
    
  class EarlyAccessForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.errorEl = this.querySelector('.early-access__error');
      this.successEl = this.querySelector('.early-access__success');
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';

      const submitButton = this.form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        redirect: 'manual',
      })
        .then((response) => {
          // Shopify's native customer/newsletter form redirects on success
          // and re-renders the page (200, not redirected) when it rejects
          // the submission (invalid email, etc). With redirect: 'manual',
          // a same-origin redirect surfaces as an opaque response -- that
          // is the success signal here, since this form has no JSON API.
          const succeeded = response.type === 'opaqueredirect' || response.status === 0 || response.ok;
          if (succeeded) {
            this.showSuccess();
          } else {
            this.showError();
          }
        })
        .catch(() => {
          this.showError();
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = false;
        });
    }

    showSuccess() {
      this.form.hidden = true;
      this.successEl.hidden = false;
    }

    showError() {
      this.errorEl.textContent = this.getAttribute('data-error-message');
      this.errorEl.hidden = false;
    }
  }

  customElements.define('early-access-form', EarlyAccessForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-grid"] && !Shopify.designMode) return;
  try {
    
  class LookbookGallery extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.lookbook__modal');
      this.modalImg = this.querySelector('.lookbook__modal-img');
      if (!this.modal) return;

      this.querySelectorAll('.lookbook__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          this.modalImg.src = trigger.dataset.lookbookSrc;
          this.modalImg.alt = trigger.dataset.lookbookAlt || '';
          if (typeof this.modal.showModal === 'function') {
            this.modal.showModal();
          } else {
            this.modal.setAttribute('open', '');
          }
        });
      });

      const close = () => {
        if (typeof this.modal.close === 'function') {
          this.modal.close();
        } else {
          this.modal.removeAttribute('open');
        }
      };

      this.querySelector('.lookbook__close').addEventListener('click', close);
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) close();
      });

      this.querySelectorAll('.lookbook__video video').forEach((v) => {
        v.muted = true;
        v.setAttribute('playsinline', '');
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      });
    }
  }

  if (!customElements.get('lookbook-gallery')) {
    customElements.define('lookbook-gallery', LookbookGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
